import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { Form } from 'semantic-ui-react';
import { ENTITY_PROPERTY } from '../../../utils/constants';

const messages = defineMessages({
  'placeholder': {
    id: 'trendLabels.placeholder',
    defaultMessage: 'Labels'
  },
  'closeButton.text': {
    id: 'trendLabels.closeButton.text',
    defaultMessage: 'Close'
  },
  'header.text': {
    id: 'trendLabels.header.text',
    defaultMessage: 'Labels'
  },
  'button.text': {
    id: 'trendLabels.button.text',
    defaultMessage: 'Labels'
  }
});

const TrendLabels = injectIntl(({
  trend,
  labels,
  label,
  isLoading,
  onChange,
  intl: {
    formatMessage
  }
}) => (
  <Form.Select
    clearable
    label={label}
    loading={isLoading}
    disabled={isLoading}
    fluid
    allowAdditions
    multiple
    search
    value={trend ? trend.labels : []}
    onChange={(e, { value }) => onChange({
      ...trend,
      [ENTITY_PROPERTY.TREND.LABELS]: value 
    })}
    options={_.map(labels, name => ({
      key: name,
      text: name,
      value: name 
    }))}
    placeholder={formatMessage(messages['placeholder'])} />
));

TrendLabels.propTypes = {
  trend: PropTypes.object,
  labels: PropTypes.array,
  isLoading: PropTypes.bool,
  onChange: PropTypes.func
};

TrendLabels.displayName = 'TrendLabels';

export default TrendLabels;